module.exports = __webpack_public_path__ + "img/Sea cucumber.586892cb.png";